import request from '@/utils/request'
import { baseURL } from '@/utils/getawayModule'

/***
 *
 * 分页查询球场比赛 get
 * @param query 分页参数
 * @return request
 * */
export function getRacesList(query) {
  return request({
    url: `${baseURL.businessApi}/race-raise/page`,
    method: 'get',
    params: query
  })
}

export function getApplyList(raceId, query) {
  return request({
    url: `${baseURL.businessApi}/race-raise-apply/${raceId}`,
    method: 'get',
    params: query
  })
}

/**
 * 查询比赛设置
 * @param type
 * @returns {AxiosPromise}
 */
export function getFormConfig(type) {
  return request({
    url: `${baseURL.businessApi}/formConfig/type`,
    method: 'get',
    params: {type}
  })
}
/**
 * 保存球场比赛设置
 * @param data
 * @returns {AxiosPromise}
 */
export function saveFormConfig(data) {
  return request({
    url: `${baseURL.businessApi}/formConfig/type`,
    method: 'post',
    data: data
  })
}

/**
 * 修改球场比赛
 * @param id
 * @returns {AxiosPromise}
 */
export function editRacesById(id, data) {
  return request({
    url: `${baseURL.businessApi}/race-raise/${id}`,
    method: 'post',
    data: data
  })
}

/**
 * 添加球场比赛
 * @returns {AxiosPromise}
 */
export function addRaces(data) {
  return request({
    url: `${baseURL.businessApi}/race-raise`,
    method: 'post',
    data: data
  })
}

/**
 * 删除球场比赛
 * @param id
 * @returns {AxiosPromise}
 */
export function deleteRacesById(id) {
  return request({
    url: `${baseURL.businessApi}/race-raise/${id}`,
    method: 'delete'
  })
}

/**
 * 删除球场比赛
 * @param id
 * @returns {AxiosPromise}
 */
export function deleteApplyById(id) {
  return request({
    url: `${baseURL.businessApi}/race-raise-apply/${id}`,
    method: 'delete'
  })
}

/**
 * 修改球场比赛报名
 * @param data
 * @param id
 * @returns {AxiosPromise}
 */
export function modifyRacesApplyById(data, id) {
  return request({
    url: `${baseURL.businessApi}/race-raise-apply/${id}`,
    method: 'post',
    data: data
  })
}



